import { Box, ButtonBase, Collapse, Stack, Tooltip, Typography } from "@mui/material";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import React from "react";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

export function CollapsableCard({
  title,
  tooltip,
  rightAdornment,
  headerMargin,
  startCollapsed = false,
  disabled = false,
  contentHeight,
  ...props
}) {
  const [collapsed, setCollapsed] = React.useState(startCollapsed);

  React.useEffect(() => {
    setCollapsed(startCollapsed);
  }, [startCollapsed]);

  return (
    <Box
      {...props}
      sx={{
        borderRadius: 3,
        border: (theme) => "1px solid " + theme.palette.background.border,
        padding: 2,
        backgroundColor: props.backgroundColor ? props.backgroundColor : "White",
        ...props.sx,
      }}
    >
      <Stack direction="row" justifyContent="space-between">
        <div>
          <ButtonBase
            disabled={disabled}
            sx={{ display: "flex", justifyContent: "center", alignItems: "center", borderRadius: 3 }}
            disableRipple
            onClick={() => setCollapsed((prevState) => !prevState)}
          >
            <ChevronRightIcon
              style={{
                transition: "transform 0.3s ease",
                transform: collapsed ? "rotate(0deg)" : "rotate(90deg)",
              }}
            />
            <Typography
              fontWeight="700"
              fontSize={20}
              noWrap
              sx={{
                textTransform: "capitalize",
                marginLeft: 1,
                width: "100%",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {title}
            </Typography>
          </ButtonBase>
        </div>
        <Stack direction="row" alignItems="center">
          {rightAdornment}
          {tooltip != null && (
            <Tooltip title={tooltip}>
              <InfoOutlinedIcon sx={{ ml: 1, cursor: "pointer", opacity: 0.2 }} />
            </Tooltip>
          )}
        </Stack>
      </Stack>
      <Collapse unmountOnExit in={!collapsed}>
        <Box sx={{ marginTop: headerMargin != null ? headerMargin : 3, height: contentHeight }}>{props.children}</Box>
      </Collapse>
    </Box>
  );
}
